import { render, staticRenderFns } from "./UserManager.vue?vue&type=template&id=98c2c302&scoped=true&"
import script from "./UserManager.vue?vue&type=script&lang=js&"
export * from "./UserManager.vue?vue&type=script&lang=js&"
import style0 from "./UserManager.vue?vue&type=style&index=0&id=98c2c302&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c2c302",
  null
  
)

export default component.exports